// Mettre à jour une adresse wallet
export async function updateWalletAddress(id, wallet) {
  const res = await fetch(`/api/wallet-address/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(wallet)
  });
  if (!res.ok) throw new Error('Erreur mise à jour wallet');
  return await res.json();
}
// Récupérer toutes les connexions (entities)
export async function getConnectionEntities() {
  const res = await fetch('/api/connection-entity');
  if (!res.ok) throw new Error('Erreur récupération connexions');
  return await res.json();
}

// Récupérer tous les credentials
export async function getConnectionCredentials() {
  const res = await fetch('/api/connection-credentials');
  if (!res.ok) throw new Error('Erreur récupération credentials');
  return await res.json();
}

// Récupérer toutes les adresses wallets
export async function getWalletAddresses() {
  const res = await fetch('/api/wallet-address');
  if (!res.ok) throw new Error('Erreur récupération wallets');
  return await res.json();
}

// Supprimer une connexion (entity)
export async function deleteConnectionEntity(id) {
  const res = await fetch(`/api/connection-entity/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Erreur suppression connexion');
  return true;
}

// Supprimer un credential
export async function deleteConnectionCredentials(id) {
  const res = await fetch(`/api/connection-credentials/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Erreur suppression credentials');
  return true;
}

// Supprimer une adresse wallet
export async function deleteWalletAddress(id) {
  const res = await fetch(`/api/wallet-address/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Erreur suppression wallet');
  return true;
}
// Nouvelle API pour la nouvelle architecture backend (connection_entity, credentials, wallet_address)
export async function createConnectionEntity(entity) {
  const res = await fetch('/api/connection-entity', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(entity)
  });
  if (!res.ok) throw new Error('Erreur création connexion');
  return await res.json();
}

export async function createConnectionCredentials(credentials) {
  const res = await fetch('/api/connection-credentials', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials)
  });
  if (!res.ok) throw new Error('Erreur création credentials');
  return await res.json();
}

export async function createWalletAddress(wallet) {
  const res = await fetch('/api/wallet-address', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(wallet)
  });
  if (!res.ok) throw new Error('Erreur création wallet');
  return await res.json();
}
// API calls for connection management

export async function storeApiKey({ userId, exchange, apiKey, apiSecret, passphrase, password }) {
  const payload = { userId, exchange, apiKey, apiSecret };
  if (passphrase) payload.passphrase = passphrase;
  if (password) payload.password = password;
  const res = await fetch('/api/connections/store-key', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  if (!res.ok) throw new Error('Erreur lors de l’enregistrement de la clé API');
  return true;
}

export async function removeApiKey({ userId, exchange }) {
  const url = `/api/connections/remove-key?userId=${encodeURIComponent(userId)}&exchange=${encodeURIComponent(exchange)}`;
  const res = await fetch(url, { method: 'DELETE' });
  if (!res.ok) throw new Error('Erreur lors de la suppression de la clé API');
  return true;
}

// Nouvelle version : synchronisation via connection_entity et credentials
export async function fetchBalanceWithCredentials({ userId, exchange }) {
  const res = await fetch('/api/connections/fetch-balance', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, exchange })
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Erreur lors de la synchronisation');
  }
  return await res.json();
}
